import * as React from "react";
// UI Frameworks
import { Form, Checkbox, Row, Col, Input as AntdInput } from "antd";
import { FormComponentProps } from "antd/lib/form";
// Shared components
import Button from "components/Button";
import Input from "components/Input";
// Local components
import TermsOfService from "../TermsOfService";
// Utilities and hooks
import * as R from "ramda";
import useUser from "hooks/useUser";
// Styles
import styles from "./index.module.scss";

interface IProps extends FormComponentProps {
	store: any;
	onSubmit: (data: any) => void;
}

const RegisterForm: React.FC<IProps> = props => {
	const { register } = useUser();
	const { store, form, onSubmit } = props;
	const { getFieldDecorator } = form;
	const [loading, setLoading] = React.useState(false);
	const [showModal, setShowModal] = React.useState(false);

	function handleSubmit(e: React.FormEvent): void {
		e.preventDefault();

		form.validateFields(async (err, values) => {
			if (!err) {
				try {
					setLoading(true);
					await register(
						R.omit(["rulesAcception", "confirmPwd"], {
							...values,
							mobile: store.mobile,
							code: store.code,
						}) as Account.User,
					);

					onSubmit(values);
					setLoading(false);
				} catch (error) {
					setLoading(false);
				}
			}
		});
	}

	function validateToNextPassword(_: any, value: string, callback: any) {
		if (!value) {
			callback("لطفا رمزعبور را وارد کنید");
		} else if (value && value.length < 6) {
			callback("رمز عبور باید حداقل از 6 حرف تشکیل شده باشد");
		} else {
			callback();
		}
	}

	function compareToFirstPassword(_: any, value: string, callback: any) {
		if (!value) {
			callback("لطفا مجدد رمز عبور خود را وارد کنید");
		} else if (value && value !== form.getFieldValue("password")) {
			callback("رمزهای عبور وارد شده یکسان نمی باشند!");
		} else {
			callback();
		}
	}

	function validateRules(_: any, value: boolean, callback: any) {
		if (!value) {
			callback("لطفا قوانین و مقررات را مطالعه و سپس تایید نمایید");
		} else {
			callback();
		}
	}

	function onCloseModal() {
		setShowModal(false);
	}

	function showRulesModal(e: React.FormEvent) {
		e.preventDefault();
		e.stopPropagation();
		setShowModal(true);
	}

	return (
		<Form onSubmit={handleSubmit} className={styles["register-form"]}>
			<Row type="flex" justify="space-between">
				<Col span={11}>
					<Form.Item label="نام">
						{getFieldDecorator("firstName", {
							rules: [
								{
									required: true,
									transform: value => (value ? value.trim() : value),
									message: "لطفا نام خود را وارد نمایید",
								},
							],
						})(<Input />)}
					</Form.Item>
				</Col>
				<Col span={11}>
					<Form.Item label="نام خانوادگی">
						{getFieldDecorator("lastName", {
							rules: [
								{
									required: true,
									transform: value => (value ? value.trim() : value),
									message: "لطفا نام خانوادگی خود را وارد نمایید",
								},
							],
						})(<Input />)}
					</Form.Item>
				</Col>
			</Row>
			<Form.Item label="کد معرف">{getFieldDecorator("referralNumber", {})(<Input />)}</Form.Item>
			<Form.Item label="رمز عبور">
				{getFieldDecorator("password", {
					initialValue: store.password,
					rules: [
						{
							validator: validateToNextPassword,
						},
					],
				})(<AntdInput.Password className={styles["register-form__password-input"]} />)}
			</Form.Item>
			<Form.Item label="تکرار رمز عبور">
				{getFieldDecorator("confirmPwd", {
					rules: [
						{
							validator: compareToFirstPassword,
						},
					],
				})(<AntdInput.Password className={styles["register-form__password-input"]} />)}
			</Form.Item>
			<Form.Item>
				{getFieldDecorator("rulesAcception", {
					valuePropName: "checked",
					rules: [
						{
							validator: validateRules,
							required: true,
						},
					],
				})(
					<Checkbox onClick={e => showRulesModal(e)}>
						<span className={styles["register-form__rules"]} onClick={e => showRulesModal(e)}>
							قوانین و مقررات
						</span>
						<span> را می پذیرم </span>
					</Checkbox>,
				)}
			</Form.Item>
			<Form.Item>
				{getFieldDecorator("coworker", {
					valuePropName: "checked",
					initialValue: store.coworker,
				})(
					<Checkbox>
						<span>همکار هستم</span>
					</Checkbox>,
				)}
			</Form.Item>
			<Form.Item className="button-center">
				<Button htmlType="submit" primary loading={loading}>
					ثبت نام
				</Button>
			</Form.Item>
			<TermsOfService shouldVisible={showModal} onClose={onCloseModal} />
		</Form>
	);
};

export default Form.create<IProps>({ name: "registry_form" })(RegisterForm);
